import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

interface PrivateRouteProps extends RouteProps {
  children?: React.ReactNode; // Make 'children' optional
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, ...rest }) => {
  const isAuthenticated = !!localStorage.getItem('user');

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        isAuthenticated ? (
          children ? (
            children
          ) : (
            rest.render ? rest.render(routeProps) : null // Pass routeProps to the render function
          )
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: routeProps.location }, // Pass location for redirection
            }}
          />
        )
      }
    />
  );
};
